<template>
<div class="app-breadcrumb">
  <el-breadcrumb
    class="breadcrumb-list"
    separator="/"
  >
    <transition-group name="breadcrumb">
      <template v-for="(item,index)  in levelList">
        <el-breadcrumb-item :key="item.path" v-if="item.meta.title">
          <span v-if="item.redirect==='noredirect'||index==levelList.length-1" class="no-redirect">{{item.meta.title}}</span>
          <router-link v-else :to="{name: item.name}">{{item.meta.title}}</router-link>
        </el-breadcrumb-item>
      </template>
      
    </transition-group>
  </el-breadcrumb>
  <div class="breadcrumb-name">
    {{ currentNameTxt }}
  </div>
</div>
  
</template>

<script>
export default {
  created() {
    this.getBreadcrumb()
  },
  data() {
    return {
      levelList: null
    }
  },
  computed: {
    currentNameTxt () {
      return this.levelList.length > 0 ? this.levelList[0].meta.title : ''
    }
  },
  watch: {
    $route() {
      this.getBreadcrumb()
    }
  },
  methods: {
    getBreadcrumb() {
      // var matched = this.$route.matched.filter(item => item.name)
      // const first = matched[0]
      // if (first && first.name === 'Dashboard') {
      //   matched = [{ path: '/dashboard', meta: { title: 'Dashboard' }}].concat(matched)
      // }
      this.levelList = this.$route.matched.filter(item => item.name)
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .app-breadcrumb.el-breadcrumb {
    display: inline-block;
    font-size: 20px;
    line-height: 60px;
    margin-left: 10px;
    .no-redirect {
      color: #97a8be;
      cursor: text;
    }
    vertical-align: middle;
  }

  .app-breadcrumb {
    padding: 15px 24px 18px;
    background: #fff;
    border-bottom: 1px solid #D2D1D1;
    .breadcrumb-list {
      line-height: 22px;
      .el-breadcrumb__inner.is-link, .el-breadcrumb__inner a { font-weight: normal; }
    }
    .breadcrumb-name {
      line-height: 28px;
      margin-top: 12px;
      font-size: 28px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Breadcrumb/index.vue